import DemandPlannerActions from "../actions/demandPlannerActions";

const DemandPlannerReducer = (
  state = {
    isDemandPlannerLoading: false, demandPlannerHasError: false,
    isDemandPlannerSecMatLoading: false, demandPlannerSecMatHasError: false,
    isDemandPlannerSecMatSaleMskuLoading: false, demandPlannerSecMatHasSaleMskuError: false,
    isDemandPlannerSecYoyLoading: false, demandPlannerSecYoyHasError: false,
  },
  action
) => {
  switch (action.type) {
    case DemandPlannerActions.DEMAND_PLANNER_REQUEST:
      return {
        ...state,
        isDemandPlannerLoading: true,
        demandPlannerHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_SUCCESSFUL:
      return {
        ...state,
        isDemandPlannerLoading: false,
        demandPlanner: action.data,
        demandPlannerHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDemandPlannerLoading: false,
        demandPlannerHasError: true,
        demandPlanner: []
      };


    case DemandPlannerActions.DEMAND_PLANNER_SEC_MAT_REQUEST:
      return {
        ...state,
        isDemandPlannerSecMatLoading: true,
        demandPlannerSecMatHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_SEC_MAT_SUCCESSFUL:
      return {
        ...state,
        isDemandPlannerSecMatLoading: false,
        demandPlannerSecMat: action.data,
        demandPlannerSecMatHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_SEC_MAT_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDemandPlannerSecMatLoading: false,
        demandPlannerSecMatHasError: true,
        demandPlannerSecMat: []
      };


    case DemandPlannerActions.DEMAND_PLANNER_SEC_MAT_SALE_MSKU_REQUEST:
      return {
        ...state,
        isDemandPlannerSecMatSaleMskuLoading: true,
        demandPlannerSecMatHasSaleMskuError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_SEC_MAT_SALE_MSKU_SUCCESSFUL:
      return {
        ...state,
        isDemandPlannerSecMatSaleMskuLoading: false,
        demandPlannerSecMatSaleMsku: action.data,
        demandPlannerSecMatHasSaleMskuError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_SEC_MAT_SALE_MSKU_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDemandPlannerSecMatSaleMskuLoading: false,
        demandPlannerSecMatHasSaleMskuError: true,
        demandPlannerSecMatSaleMsku: []
      };

      
    case DemandPlannerActions.DEMAND_PLANNER_SEC_YOY_REQUEST:
      return {
        ...state,
        isDemandPlannerSecYoyLoading: true,
        demandPlannerSecYoyHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_SEC_YOY_SUCCESSFUL:
      return {
        ...state,
        isDemandPlannerSecYoyLoading: false,
        demandPlannerSecYoy: action.data,
        demandPlannerSecYoyHasError: false
      };
    case DemandPlannerActions.DEMAND_PLANNER_SEC_YOY_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDemandPlannerSecYoyLoading: false,
        demandPlannerSecYoyHasError: true,
        demandPlannerSecYoy: null
      };
    default:
      return {
        ...state
      };
    //   break;
  }
};

export default DemandPlannerReducer;
